import { Component, computed, inject, signal, viewChild } from '@angular/core';
import { OrganizationsStore } from '../../../organizations/store/organizations.store';
import { InputError, Button } from 'excellence-ui';
import { EditFormSkeleton } from '../../../../shared/components/edit-form-skeleton/edit-form-skeleton';
import { NgIcon } from '@ng-icons/core';
import { OrganizationCreateAddressForm } from '../../../organizations/components/organization-create-address-form/organization-create-address-form';
import { toPayload } from '../../../organizations/components/organization-create-address-form/definitions';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-settings-address-page',
  imports: [
    InputError,
    EditFormSkeleton,
    Button,
    NgIcon,
    OrganizationCreateAddressForm,
    TranslocoPipe,
  ],
  templateUrl: './settings-address-page.html',
})
export class SettingsAddressPage {
  private organizationsStore = inject(OrganizationsStore);

  private formComponent = viewChild(OrganizationCreateAddressForm);
  protected form = computed(() => this.formComponent()?.organizationForm());

  protected state = this.organizationsStore.selected;

  protected showValidationErrors = signal(false);
  protected isUpdateLoading = computed(() => !!this.state()?.isEditLoading);
  protected updateError = computed(() => this.state()?.editError);

  protected async onSubmit() {
    const form = this.formComponent();
    if (!form) {
      throw new Error('form component not found');
    }
    if (!form.organizationForm().valid()) {
      form.markAsTouched();
      this.showValidationErrors.set(true);
      return;
    }
    const orgaID = this.state()!.id;
    const value = form.organizationForm().value();
    await this.organizationsStore.update(orgaID, toPayload(value));
    form.organizationForm().reset();
  }
}
